import React, { useState, useEffect, useRef } from 'react';
import styles from '../../css/about/ContactUs.module.css';
import '../../css/about/contactsend.css';
import constactImage from '../../assest/about/9889a6af2e15b9cd7fa0cf51f36c75993e41f7fa (2).png';

function ContactUs() {
    const [formData, setFormData] = useState({
        name: '',
        tel: '',
        email: '',
        notes: '',
        recaptcha: ''
    });

    const [errors, setErrors] = useState({
        name: '',
        tel: '',
        email: '',
        notes: '',
        recaptcha: ''
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const recaptchaRef = useRef(null);
    const widgetId = useRef(null);

    useEffect(() => {
        // const loadRecaptcha = () => {
        //     if (window.grecaptcha && recaptchaRef.current && widgetId.current === null) {
        //         window.grecaptcha.ready(() => {
        //             widgetId.current = window.grecaptcha.render(recaptchaRef.current, {
        //                 'sitekey': '6LcGXZ0rAAAAAE-Mmr4fRR_VNsbs9EcmK8toLmnu',
        //                 'callback': handleRecaptchaChange,
        //             });
        //         });
        //     } else if (!window.grecaptcha) {
        //         const script = document.createElement('script');
        //         script.src = `https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit`;
        //         script.async = true;
        //         script.defer = true;
        //         document.body.appendChild(script);

        //         window.onloadCallback = () => {
        //             window.grecaptcha.ready(() => {
        //                 if (recaptchaRef.current && widgetId.current === null) {
        //                     widgetId.current = window.grecaptcha.render(recaptchaRef.current, {
        //                         'sitekey': '6LcGXZ0rAAAAAE-Mmr4fRR_VNsbs9EcmK8toLmnu',
        //                         'callback': handleRecaptchaChange,
        //                     });
        //                 }
        //             });
        //         };
        //     }
        // };

        // loadRecaptcha();

        return () => {
            if (widgetId.current !== null && window.grecaptcha) {
                window.grecaptcha.reset(widgetId.current);
                widgetId.current = null;
            }
        };
    }, []);

    const validateSaudiPhone = (phone) => {
        const saudiPhoneRegex = /^(009665|9665|\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/;
        return saudiPhoneRegex.test(phone);
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {
            name: '',
            tel: '',
            email: '',
            notes: '',
            recaptcha: ''
        };

        if (!formData.name.trim()) {
            newErrors.name = 'حقل الاسم مطلوب';
            valid = false;
        }

        if (!formData.tel.trim()) {
            newErrors.tel = 'حقل رقم الجوال مطلوب';
            valid = false;
        } else if (!validateSaudiPhone(formData.tel)) {
            newErrors.tel = 'يرجى إدخال رقم جوال سعودي صحيح (يبدأ بـ 05)';
            valid = false;
        }

        if (!formData.email.trim()) {
            newErrors.email = 'حقل البريد الإلكتروني مطلوب';
            valid = false;
        } else if (!validateEmail(formData.email)) {
            newErrors.email = 'يرجى إدخال بريد إلكتروني صحيح';
            valid = false;
        }

        if (!formData.notes.trim()) {
            newErrors.notes = 'حقل الملاحظات مطلوب';
            valid = false;
        } else if (formData.notes.trim().length < 10) {
            newErrors.notes = 'الملاحظات يجب أن تحتوي على الأقل 10 أحرف';
            valid = false;
        }

        // if (!formData.recaptcha) {
        //     newErrors.recaptcha = 'التحقق من reCAPTCHA مطلوب';
        //     valid = false;
        // }

        setErrors(newErrors);
        return valid;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });

        if (errors[name]) {
            setErrors({
                ...errors,
                [name]: ''
            });
        }
    };

    const handleRecaptchaChange = (token) => {
        setFormData({
            ...formData,
            recaptcha: token
        });
    };

    const closeResultModal = () => {
        setShowModal(false);
        setSubmitStatus(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);
        setShowModal(true);
        setSubmitStatus(null);
    };

    return (
        <div className={styles.container}>
            {showModal && !submitStatus && (
                <div className={styles.modalOverlay}>
                    <div className={styles.loadingModal}>
                        <div className={styles.spinner}></div>
                        <p>جاري إرسال البيانات، يرجى الانتظار...</p>
                    </div>
                </div>
            )}

            {showModal && submitStatus && (
                <div className={styles.modalOverlay}>
                    <div className={submitStatus === 'success' ? styles.successModal : styles.errorModal}>
                        <h3>
                            {submitStatus === 'success'
                                ? 'تم الإرسال بنجاح!'
                                : 'حدث خطأ أثناء الإرسال!'}
                        </h3>
                        <p>
                            {submitStatus === 'success'
                                ? 'شكراً لتواصلك معنا، سنقوم بالرد عليك في أقرب وقت ممكن.'
                                : 'عذراً، حدث خطأ أثناء محاولة إرسال رسالتك. يرجى المحاولة مرة أخرى لاحقاً.'}
                        </p>
                        <button
                            onClick={closeResultModal}
                            className={styles.modalButton}
                        >
                            موافق
                        </button>
                    </div>
                </div>
            )}

            <div className={styles.imgmap}>
                <div>
                    <img loading='lazy' src={constactImage} alt="contactus" />
                </div>
                <div>
                    <div className='map-c' width="30%">
                        <iframe
                            className='map'
                            src={"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4404.380780238425!2d46.68807167609331!3d24.542184578138418!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f0f0062f4b921%3A0xb056b3e02a58606a!2z2LTYsdmD2Kkg2K7Yt9mI2Kkg2KfZhNmF2LPYqtir2YXYsSDZhNiu2K_Zhdin2Kog2KfZhNij2LnZhdin2YQ!5e1!3m2!1sen!2ssa!4v1755351573443!5m2!1sen!2ssa"}
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="خريطة الموقع"
                        ></iframe>
                    </div>
                </div>
            </div>

            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="name">الاسم</label>
                    <br />
                    <input
                        type="text"
                        name="name"
                        id="name"
                        value={formData.name}
                        onChange={handleInputChange}
                    />
                    {errors.name && <div className={styles.errorText}>{errors.name}</div>}
                </div>

                <div>
                    <label htmlFor="tel">رقم الجوال</label>
                    <br />
                    <input
                        type="tel"
                        name="tel"
                        id="tel"
                        value={formData.tel}
                        onChange={handleInputChange}
                        placeholder="مثال: 0512345678"
                    />
                    {errors.tel && <div className={styles.errorText}>{errors.tel}</div>}
                </div>

                <div>
                    <label htmlFor="email">البريد الالكتروني</label>
                    <br />
                    <input
                        type="email"
                        name="email"
                        id="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="مثال: example@domain.com"
                    />
                    {errors.email && <div className={styles.errorText}>{errors.email}</div>}
                </div>

                <div>
                    <label htmlFor="notes">ملاحظتك</label>
                    <br />
                    <textarea
                        name="notes"
                        id="notes"
                        value={formData.notes}
                        onChange={handleInputChange}
                        rows="5"
                    ></textarea>
                    {errors.notes && <div className={styles.errorText}>{errors.notes}</div>}
                </div>

                <div className={styles.gRecaptcha} data-sitekey=''>
                    <div ref={recaptchaRef}></div>
                    <br/>
                    {errors.recaptcha && <div className={styles.errorText}>{errors.recaptcha}</div>}
                </div>

                <button type="submit" disabled={isSubmitting} className={styles.submitButton}>
                    {isSubmitting ? 'جاري الإرسال...' : 'إرسال'}
                </button>
            </form>
        </div>
    );
}

export default ContactUs;